import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";
import { NAV_LINKS, LOGO_URL, waLink, WHATSAPP_DISPLAY } from "../lib/data";
import { POLICY_NAV } from "../lib/policies";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-brand-dark text-brand-bg overflow-hidden">
    <div className="noise-overlay" />
    <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src={LOGO_URL} alt="40X Leaves" className="h-14 w-auto bg-white/95 rounded-xl p-2" />
          <p className="mt-6 font-serif text-2xl md:text-3xl leading-tight max-w-md text-brand-bg/90">
            Your greens shouldn't travel further than you do.
          </p>
          <p className="mt-4 text-sm text-brand-bg/50 max-w-sm leading-relaxed">
            40X Leaves Microgreens Private Limited — hyperlocal microgreens, grown in your
            neighbourhood across Kerala.
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand-sprout mb-5">
            Explore
          </p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-brand-bg/70 hover:text-brand-sprout transition-colors duration-300 text-sm"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand-sprout mb-5">
            Reach us
          </p>
          <ul className="space-y-3 text-sm text-brand-bg/70">
            <li>
              <a
                href={waLink("Hi 40X Leaves, I'd like to get started. My pincode is ")}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-brand-sprout transition-colors duration-300"
              >
                WhatsApp: {WHATSAPP_DISPLAY}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} />
              <a href="mailto:hello@40xleaves.in" className="hover:text-brand-sprout transition-colors">
                hello@40xleaves.in
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} />
              <a href="mailto:franchise@40xleaves.in" className="hover:text-brand-sprout transition-colors">
                franchise@40xleaves.in
              </a>
            </li>
          </ul>
          <div className="flex items-center gap-4 mt-6">
            <a href="https://www.instagram.com/40x.leaves/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-brand-bg/60 hover:text-brand-sprout transition-colors"><Instagram size={20} /></a>
            <a href="https://www.facebook.com/profile.php?id=61553614486350" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-brand-bg/60 hover:text-brand-sprout transition-colors"><Facebook size={20} /></a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-brand-bg/60 hover:text-brand-sprout transition-colors"><Youtube size={20} /></a>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap gap-x-6 gap-y-3">
        {POLICY_NAV.map((p) => (
          <Link
            key={p.slug}
            to={p.path}
            data-testid={`footer-legal-${p.slug}`}
            className="text-xs font-mono uppercase tracking-wider text-brand-bg/50 hover:text-brand-sprout transition-colors"
          >
            {p.label}
          </Link>
        ))}
      </div>

      <div className="mt-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-brand-bg/40 font-mono">
        <span>© {new Date().getFullYear()} 40X Leaves Microgreens Private Limited</span>
        <span>Grown hyperlocally · Harvested same-day · Delivered fresh</span>
      </div>
    </div>
  </footer>
);
